module.exports = __webpack_public_path__ + "static/media/match_people.5205f1b9.jpg";